<template lang="pug">
div

  //- div.mt-3(v-if="!isSearching")
  div.mt-3
    .container-list
    b-tabs(pills card lazy v-model="selectedTab" @activate-tab="tabActivated" :key="tabsKey")
      //- todo: desparchear la condición de === 'Pendientes' cuando se arregle el contador
      b-tab(
        v-for="(tab, index) in processedTabs"
        :key="tab.title"
        :title-item-class="isSearched ? 'd-none' : 'text-black'"
      )
        template(#title)
          // Spinner sólo mientras hay una carga en curso para esa tab
          span(v-if="loadingNowFor === tab.title && tab.total !== 0")
            b-spinner(small)
            |  {{ tab.title || tab.states[0] }}
          span(v-else)
            | {{ tab.title || tab.states[0] }} ({{ tab.total }})
    OtTable(
      ref="otTable"
      :otItems="tabActiveData"
      :loading="loading"
      :loadingTabs="loadingTabs"
      :titleTabSelected="titleTabSelected"
      :sortBy="sortBy"
      :sortDesc="sortDesc"
      :key="tableKeyVersion"
      @changed="reloadCurrentTab"
      @sortingChanged="handleSortingChanged"
      @refresh-list="refreshList"
      @refresh-single-ot="refreshSingleOt"
    )
  div.d-flex.flex-row-reverse()
    b-pagination(
      v-model="currentPage"
      :total-rows="numberRows"
      :per-page="pageSize"
      prev-text="Ant."
      next-text="Sig."
      @change="handlePageChange"
    )
  //- div.text-center.mt-3(v-if="isSearching")
  //-   b-spinner(small) Cargando
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'
import { mapState, mapWritableState } from 'pinia'
import { io } from 'socket.io-client'
import settings from '@/../settings'
import { useDashboardStore } from '../../../pinia/views/useDashboardStore'
import OtTable from './OtTable.vue'

export default {
  name: 'GenericOTList',
  props: {
    tabs: { type: Array, required: false },
    dontSearch: { type: Boolean, default: false },
    otList: { type: Array },
    byDashboard: { type: Boolean, default: false },
  },
  components: { OtTable },
  data() {
    return {
      currentPage: 1,
      pageSize: 20,
      selectedTab: 0,
      selectedIndex: 0,
      loading: true,
      justAdmin: false,
      tabActiveData: { count: 0, results: [] },
      numberRows: 0,
      isInitialData: true,
      titleTabSelected: '',
      loadingTabs: null,
      dontSearchValue: false,
      flagWatcher: false,
      loadingFiltersFromUrl: false,

      // Precarga con prioridad
      preloadQueue: [], // [{ name, apiName, aprobadas_3x3 }]
      isDrainingQueue: false,
      prefetchController: null,
      loadingNowFor: null,

      // Forzar re-render del OtTable cuando cambie la data
      tableKeyVersion: 0,

      // Contadores por estado desde el último response del backend
      estadosCounters: {},
    }
  },
  async created() {
    this.dontSearchValue = this.$route.params.dontSearch

    // Load sort from URL query params
    this.loadSortFromUrl()

    // Load filters from URL query params
    this.loadFiltersFromUrl()

    // Load tab from URL query params (will set selectedTab if found)
    const tabFromUrl = this.loadTabFromUrl()

    // Load page from URL query params
    const initialPage = this.loadPageFromUrl()

    if (!this.$route.params.dontSearch) {
      this.SET_IS_INITIAL_DATA(true)
      if (this.controller) this.controller.abort()
      this.controller = new AbortController()
      const { signal } = this.controller

      try {
        this.SET_CURRENT_OTS_BY_STATES([])

        const statesWithOt = await this.getStatesWithOT({
          ...this.queryParams,
          tecnico_asignado_id: this.autoTecnicoId,
        })
        const { tabs } = this
        const {
          data: { estados: statesWithCount },
        } = statesWithOt

        // Primer tab con count > 0
        const foundIndex = tabs.findIndex((tab) => {
          return tab.states.some((state) => {
            if (state === 'Reparado' && tab.params?.aprobadas_3x3) {
              return statesWithCount['Reparado 3x3'] > 0
            }
            return statesWithCount[state] > 0
          })
        })

        // Use URL tab if available, otherwise use first tab with results
        const initialTabIndex =
          tabFromUrl !== false && tabFromUrl !== undefined
            ? this.selectedIndex
            : foundIndex !== -1
            ? foundIndex
            : 0

        this.selectedIndex = initialTabIndex
        const initialTabParams = (this.tabs[initialTabIndex] || {}).params || {}

        const response = await this.searchOT({
          estados: (this.tabs[initialTabIndex] || {}).states || [],
          ot_list: this.otList,
          page: initialPage,
          fecha_ingreso: null,
          tecnico_asignado_id: this.filters.tecnico || this.autoTecnicoId,
          tipo_servicio: null,
          sucursal: null,
          filters: this.queryParams,
          ...(initialTabParams.aprobadas_3x3 !== undefined
            ? { aprobadas_3x3: initialTabParams.aprobadas_3x3 }
            : {}),
          signal,
          ordering: this.sortBy
            ? this.sortDesc
              ? `-${this.sortBy}`
              : this.sortBy
            : null,
        })

        this.loading = false
        this.selectedIndex = initialTabIndex

        // Actualizar contadores locales con el primer response
        this.estadosCounters = (response.data && response.data.estados) || {}

        // If the initial tab has no results (can happen with URL filters),
        // find the first tab that actually has filtered results and fetch it
        const filteredEstados = response.data.estados || {}
        const hasActiveFilters = this.getStatusFilter(this.queryParams)

        if (response.data.count === 0 && hasActiveFilters) {
          // Find first tab with filtered results > 0
          const correctIndex = tabs.findIndex((tab) => {
            return tab.states.some((state) => {
              if (state === 'Reparado' && tab.params?.aprobadas_3x3) {
                return filteredEstados['Reparado 3x3'] > 0
              }
              return filteredEstados[state] > 0
            })
          })

          if (correctIndex !== -1 && correctIndex !== foundIndex) {
            this.selectedIndex = correctIndex
            const correctResponse = await this.searchOT({
              estados: this.tabs[correctIndex].states,
              ot_list: this.otList,
              filters: this.queryParams,
              signal,
              ordering: this.sortBy
                ? this.sortDesc
                  ? `-${this.sortBy}`
                  : this.sortBy
                : null,
            })
            this.setTabDataAndBump(correctResponse.data)
            this.estadosCounters =
              (correctResponse.data && correctResponse.data.estados) || {}
          } else {
            this.setTabDataAndBump(response.data)
          }
        } else {
          this.setTabDataAndBump(response.data)
        }

        const { estados } = response.data
        const estadosConMasDeCero = Object.entries(estados)
          .filter(([, count]) => Number(count) > 0)
          .map(([name]) => name)

        // Estructura inicial (loaded=false) para que tabActivated cargue on-demand
        const initialTabsData = estadosConMasDeCero.map((name) => ({
          name,
          ots: [],
          total: 0,
          loaded: false,
        }))
        this.SET_CURRENT_OTS_BY_STATES({ ots: initialTabsData })

        // Sync selectedTab (visual index in processedTabs) with selectedIndex (index in this.tabs)
        this.$nextTick(() => {
          const ptIdx = this.processedTabs.findIndex(
            (t) => t._idx === this.selectedIndex // eslint-disable-line no-underscore-dangle
          )
          if (ptIdx !== -1) {
            this.selectedTab = ptIdx
          }
        })

        // No pre-cargar el resto de tabs. Solo la activa cuando el usuario la seleccione.
        this.numberRows = response.data.count || 0
        // Re-set initialPage after numberRows is set to avoid b-pagination clamping to 1
        this.$nextTick(() => {
          this.currentPage = initialPage
        })
      } catch (error) {
        if (error.name === 'AbortError') {
          console.log('Petición cancelada')
        } else {
          console.error('Error en searchOT:', error)
        }
      } finally {
        // this.loading = false;
      }
    } else {
      this.loading = false
      this.setTabDataAndBump(this.dataInput || { count: 0, results: [] })
    }

    const { user } = JSON.parse(localStorage.getItem('user'))
    const groups = user.groups.filter(
      (u) =>
        u.name === 'Supervisor' || u.name === 'Técnico' || u.name === 'Gerencia'
    )
    const groupsJustAdmin = user.groups.filter(
      (u) => u.name === 'Administrativo'
    )

    this.initWebsockets()

    if (groups.length > 0) return
    if (groupsJustAdmin.length > 0) this.justAdmin = true
  },
  beforeDestroy() {
    Object.assign(this.filters, {
      tipoServicio: 0,
      tipoCliente: null,
      fase: null,
      alertColor: [],
      tecnico: null,
      on_site: null,
      despacho: null,
    })

    this.SET_DATA_SEARCH_INPUT(null)
    this.SET_SEARCHING_FILTER(null)
    if (this.controller) this.controller.abort()
    if (this.prefetchController) this.prefetchController.abort()
  },
  destroyed() {
    if (!this.socket) return
    this.socket.disconnect()
  },
  computed: {
    ...mapGetters('AuthenticationStore', ['user']),
    ...mapGetters('OT', [
      'currentOts',
      'currentStates',
      'isSearched',
      'isSearching',
      'currentOtsByState',
      'isInitialDataState',
      'modalActionStatus',
      'dataInput',
      'searchingFilter',
      'loadingInputSearch',
    ]),
    ...mapGetters('Warehouse', ['stateIsChanged']),
    ...mapWritableState(useDashboardStore, [
      'filters',
      'sortBy',
      'sortDesc',
      'tab',
    ]),
    ...mapState(useDashboardStore, ['queryParams']),

    tabsKey() {
      return `${JSON.stringify(this.processedTabs)}-${this.selectedTab}`
    },

    countsByEstado() {
      const estados = this.estadosCounters || {}
      return Object.fromEntries(
        Object.entries(estados)
          .filter(([, count]) => Number(count) > 0)
          .map(([name, count]) => [name, Number(count)])
      )
    },

    techFilterChanged() {
      return this.filters.tecnico
    },
    autoTecnicoId() {
      const { user } = this
      if (!user || !user.groups) return null
      const functionalGroups = user.groups.filter(
        (g) => g.name !== 'SILL_USERS'
      )
      const isOnlyTechnician =
        functionalGroups.map((group) => group.name).includes('Técnico') &&
        functionalGroups.length === 1
      return isOnlyTechnician ? user.id : null
    },
    tipoDespacho() {
      return this.filters.despacho
    },
    tipoServicio() {
      return this.filters.tipoServicio
    },
    tipoCliente() {
      return this.filters.tipoCliente
    },
    alertColor() {
      return this.filters.alertColor
    },
    dataInputSeach() {
      return this.dataInput
    },

    processedTabs() {
      const baseTabs =
        this.tabs && this.tabs.length > 0
          ? this.tabs
          : [
              { title: 'Pendientes', states: ['Pendiente'], params: {} },
              { title: 'En progreso', states: ['En progreso'], params: {} },
            ]

      const hasCounts =
        this.countsByEstado && Object.keys(this.countsByEstado).length > 0

      const mapped = baseTabs.map((tab, idx) => {
        let total = 0
        if (tab.params?.aprobadas_3x3) {
          total = this.countsByEstado['Reparado 3x3'] || 0
        } else {
          total = (tab.states || []).reduce(
            (sum, s) => sum + (this.countsByEstado[s] || 0),
            0
          )
        }
        return { ...tab, total: hasCounts ? total : 0, _idx: idx }
      })

      return hasCounts ? mapped.filter((t) => t.total > 0) : mapped
    },

    estados() {
      const states = []
      this.tabs.forEach((tab) => {
        tab.states.forEach((estado) => {
          if (states.indexOf(estado) === -1) states.push(estado)
        })
      })
      return states
    },

    currentOtsFiltered() {
      // deprecated, TODO: rename and delete this property
      return this.currentOts
    },

    watchedFilters() {
      const f = this.filters
      return [
        f.tipoServicio,
        f.tipoCliente,
        f.alertColor,
        f.tecnico,
        f.on_site || null,
        f.despacho,
        f.presupuesto,
        f.garantia,
        this.sortBy,
        this.sortDesc,
      ]
    },
  },
  methods: {
    refreshList() {
      this.fetchData(this.currentPage, this.sortBy)
    },
    ...mapActions('OT', [
      'searchOT',
      'updateOtInCurrentPage',
      'addOtToResults',
      'getSingleOTAsListData',
      'removeOtFromResults',
      'otsByState',
      'getStatesWithOT',
    ]),
    ...mapActions('TechniciansStore', ['listTechnicians']),
    ...mapMutations('Warehouse', ['SET_STATE_IS_CHANGED']),
    ...mapMutations('OT', [
      'SET_CURRENT_OTS_BY_STATES',
      'SET_IS_INITIAL_DATA',
      'SET_SEARCHING_FILTER',
      'SET_DATA_SEARCH_INPUT',
    ]),

    // Helper: setea data y fuerza re-render del OtTable
    setTabDataAndBump(payload) {
      const dataObj =
        payload && typeof payload === 'object'
          ? payload
          : { count: 0, results: [] }
      this.tabActiveData = {
        count: dataObj.count || 0,
        next: dataObj.next || null,
        previous: dataObj.previous || null,
        results: Array.isArray(dataObj.results) ? dataObj.results : [],
        loaded: true,
        // permite pasar cualquier campo adicional sin romper
        ...dataObj,
      }
      this.numberRows = this.tabActiveData.count || 0
      this.tableKeyVersion += 1 // <-- fuerza remount del OtTable
    },

    // Compatibilidad
    isTabLoaded(tabTitle) {
      return this.isStateLoaded(tabTitle)
    },

    // El nombre de una tab es `title` cuando existe y el primer estado si no
    // (la plantilla resuelve `tab.title || tab.states[0]`). AssignList pasa
    // tabs sin `title`, y `currentOtsByState` indexa por este nombre.
    tabNameFor(tab) {
      if (!tab) return ''
      return tab.title || (Array.isArray(tab.states) ? tab.states[0] : '') || ''
    },

    // Cola/prioridad
    isStateLoaded(name) {
      if (!Array.isArray(this.currentOtsByState)) return false
      const s = this.currentOtsByState.find((x) => x.name === name)
      return !!(s && s.loaded)
    },

    buildInitialStateIfMissing(name) {
      const current = Array.isArray(this.currentOtsByState)
        ? [...this.currentOtsByState]
        : [] // eslint-disable-line
      if (!current.find((s) => s.name === name)) {
        current.push({ name, ots: [], total: 0, loaded: false })
        this.SET_CURRENT_OTS_BY_STATES({ ots: current })
      }
    },

    updateTodasAggregate() {
      const current = Array.isArray(this.currentOtsByState)
        ? [...this.currentOtsByState]
        : []
      const todasIndex = current.findIndex((s) => s.name === 'Todas')
      if (todasIndex === -1) return

      const loadedStates = current.filter((s) => s.name !== 'Todas' && s.loaded)
      const allOts = loadedStates.flatMap((s) => s.ots).slice(0, 10)
      const totalOts = loadedStates.reduce((sum, s) => sum + (s.total || 0), 0)

      current[todasIndex] = {
        name: 'Todas',
        ots: allOts,
        total: totalOts,
        loaded: true,
      }
      this.SET_CURRENT_OTS_BY_STATES({ ots: current })
    },

    async loadStateTask(task, signal) {
      this.buildInitialStateIfMissing(task.name)
      const resp = await this.otsByState({
        estados: [task.apiName],
        ot_list: this.otList,
        fecha_ingreso: null,
        tecnico_asignado_id: this.filters.tecnico || this.autoTecnicoId,
        tipo_servicio: null,
        sucursal: null,
        // Solo enviar aprobadas_3x3 si está explícitamente definido
        ...(task.aprobadas_3x3 !== undefined
          ? { aprobadas_3x3: task.aprobadas_3x3 }
          : {}),
        signal,
      })

      const newState = {
        name: task.name,
        ots: resp.data.results,
        total: resp.data.count,
        loaded: true,
      }

      const current = JSON.parse(JSON.stringify(this.currentOtsByState))
      const idx = current.findIndex((s) => s.name === task.name)
      if (idx !== -1) current[idx] = newState
      else current.push(newState)
      this.SET_CURRENT_OTS_BY_STATES({ ots: current })

      this.updateTodasAggregate()

      // Si justo estoy precargando el tab seleccionado por el user,
      // y aún no se activó visualmente, puedo adelantar la data:
      if (this.titleTabSelected === task.name) {
        this.setTabDataAndBump({
          count: newState.total,
          results: newState.ots,
          loaded: true,
        })
      }
    },

    async drainQueue() {
      if (this.isDrainingQueue) return
      this.isDrainingQueue = true

      try {
        while (this.preloadQueue.length && !this.searchingFilter) {
          const task = this.preloadQueue[0]

          if (this.isStateLoaded(task.name)) {
            this.preloadQueue.shift()
            continue // eslint-disable-line
          }

          if (this.prefetchController) this.prefetchController.abort()
          this.prefetchController = new AbortController()
          const { signal } = this.prefetchController

          this.loadingNowFor = task.name

          try {
            await this.loadStateTask(task, signal) // eslint-disable-line
            if (this.preloadQueue[0]?.name === task.name) {
              this.preloadQueue.shift()
            } else {
              const i = this.preloadQueue.findIndex((t) => t.name === task.name)
              if (i !== -1) this.preloadQueue.splice(i, 1)
            }
          } catch (e) {
            if (e.name !== 'AbortError') console.error('Preload error:', e)
            if (e.name === 'AbortError') return
          } finally {
            this.loadingNowFor = null
          }
        }
      } finally {
        this.isDrainingQueue = false
      }
    },

    async prioritizeTab(tabTitle) {
      if (this.isStateLoaded(tabTitle)) return

      let idx = this.preloadQueue.findIndex((t) => t.name === tabTitle) // eslint-disable-line
      if (idx === -1) {
        const isR33 = tabTitle === 'Reparado 3x3'
        this.preloadQueue.unshift({
          name: tabTitle,
          apiName: isR33 ? 'Reparado' : tabTitle,
          aprobadas_3x3: isR33,
        })
      } else if (idx > 0) {
        const [t] = this.preloadQueue.splice(idx, 1)
        this.preloadQueue.unshift(t)
      }

      if (
        this.loadingNowFor &&
        this.loadingNowFor !== tabTitle &&
        this.prefetchController
      ) {
        this.prefetchController.abort()
      }

      await this.drainQueue()
    },

    tabActivated(newTabIndex) {
      const newTabTitle = this.processedTabs[newTabIndex]?.title
      if (!newTabTitle) return

      this.titleTabSelected = newTabTitle

      // Ajustar el índice real de la tab original
      const realIdx = this.processedTabs.findIndex(
        (t) => t.title === newTabTitle
      )
      this.selectedIndex = this.processedTabs[realIdx]?._idx ?? 0 // eslint-disable-line

      // Permitir el cambio inmediato de pestaña (no bloquear con preventDefault)
      this.loading = true // Mostrar loader en la tabla
      this.loadingNowFor = newTabTitle // Spinner en título de la tab mientras carga

      if (this.isTabLoaded(newTabTitle)) {
        // Ya hay datos en store por estado → pintar altiro desde store
        this.fetchDataInitial(newTabTitle)
          .then((dataTab) => {
            this.setTabDataAndBump(dataTab)
          })
          .finally(() => {
            this.loading = false
            this.loadingNowFor = null
          })
      } else {
        // Cargar on-demand desde backend en segundo plano
        this.fetchData(1, this.sortBy, this.selectedIndex)
          .then((dataTab) => {
            this.setTabDataAndBump(dataTab)
          })
          .finally(() => {
            this.loading = false
            this.loadingNowFor = null
          })
      }
    },

    async changeTable(page = 1) {
      const args = {
        query: this.searchingFilter,
        page,
        filters: this.queryParams,
      }
      if (!this.searchingFilter) return
      const response = await this.searchOT(args)
      this.flagWatcher = false
      this.setTabDataAndBump(response.data)
    },

    async handlePageChange(page) {
      if (!this.searchingFilter) {
        let ordering = this.sortBy
        if (this.sortDesc && this.sortBy) ordering = `-${this.sortBy}`

        const actualTabName = this.processedTabs[this.selectedTab].title
        const tabIndex = this.processedTabs.find(
          (tab) => tab.title === actualTabName
        )
        const indexTabSelected = tabIndex._idx // eslint-disable-line
        const response = await this.fetchData(page, ordering, indexTabSelected)
        this.setTabDataAndBump(response)
        this.isInitialData = false
        this.currentPage = page
        // Sync page to URL
        this.syncPageToUrl(page)
      } else {
        this.changeTable(page)
      }
    },

    async handleTabChange(index, tabTitle) {
      // Ya no se usa por click del usuario (lo maneja tabActivated),
      // pero lo dejamos para reloads internos si fuese necesario.
      if (!this.isTabLoaded(tabTitle)) return
      if (this.selectedIndex === index) return

      this.loading = true
      this.selectedIndex = index
      this.titleTabSelected = tabTitle
      this.currentPage = 1

      let dataTab = []
      if (tabTitle === 'Todas') {
        this.SET_IS_INITIAL_DATA(false)
        dataTab = await this.fetchData(1, this.sortBy)
      } else {
        dataTab = this.isInitialDataState
          ? await this.fetchDataInitial(tabTitle)
          : await this.fetchData(1, this.sortBy)
      }

      this.setTabDataAndBump(dataTab)

      this.$nextTick(() => {
        const idx = this.processedTabs.findIndex(
          (tab) => tab.title === tabTitle
        )
        this.selectedTab = idx !== -1 ? idx : 0
      })
      this.loading = false
    },

    reloadCurrentTab() {
      this.handleTabChange(
        this.selectedIndex,
        this.processedTabs[this.selectedTab]?.title
      )
    },

    async refreshSingleOt(otId) {
      try {
        // Refresh silencioso: pedir actualización solo de esta OT
        // Modo lista normal: actualizar solo la fila visible y el store de página actual
        const data = await this.getSingleOTAsListData({ ot: otId })

        // Si hay un modal de acciones abierto, evitar refrescar la lista para no cerrar modales recién abiertos
        if (this.modalActionStatus) {
          return
        }
        await this.updateOtInCurrentPage({ ot: data })
        const results = Array.isArray(this.currentOts?.results)
          ? this.currentOts.results
          : this.tabActiveData.results
        const index = results.findIndex((ot) => ot.ot === otId)
        if (index !== -1) {
          const newResults = [
            ...results.slice(0, index),
            data,
            ...results.slice(index + 1),
          ]
          this.setTabDataAndBump({
            ...this.currentOts,
            results: newResults,
            count: this.currentOts?.count || this.tabActiveData.count || 0,
          })
        }
      } catch (e) {
        // silencioso
      }
    },

    handleSortingChanged(sortBy, sortDesc) {
      this.sortBy = sortBy
      this.sortDesc = sortDesc

      // Data fetch is now handled by the watchedFilters watcher
      this.syncSortToUrl(sortBy, sortDesc)
    },

    // Load sort from URL query params
    loadSortFromUrl() {
      const { query } = this.$route

      if (query.sortBy) {
        this.sortBy = query.sortBy
        this.sortDesc = query.sortDesc === 'true'

        // Use nextTick to ensure OtTable is mounted before setting internal sort
        this.$nextTick(() => {
          if (this.$refs.otTable) {
            this.$refs.otTable.internalSortBy = this.sortBy
            this.$refs.otTable.internalSortDesc = this.sortDesc
          }
        })
      }
    },

    // Load tab from URL query params
    loadTabFromUrl() {
      const { query } = this.$route
      if (query.tab) {
        const tabName = query.tab
        console.log(
          '[GenericOTList] loadTabFromUrl - Looking for tab:',
          tabName
        )

        // Find the tab index by name
        const tabIndex = this.tabs.findIndex(
          (tab) => tab.title === tabName || tab.states.includes(tabName)
        )

        if (tabIndex !== -1) {
          this.selectedTab = tabIndex
          this.selectedIndex = tabIndex
          console.log(
            '[GenericOTList] Loaded tab:',
            tabName,
            'at index:',
            tabIndex
          )
          return true
        }
        console.log(
          '[GenericOTList] Tab not found:',
          tabName,
          '- will use default'
        )
      }
      return false
    },

    // Sync tab to URL query params
    syncTabToUrl(tabTitle) {
      if (!tabTitle) return

      const currentQuery = this.$route.query
      if (currentQuery.tab !== tabTitle) {
        this.$router
          .replace({
            query: { ...currentQuery, tab: tabTitle },
          })
          .catch(() => {})
      }
    },

    // Sync page to URL query params
    syncPageToUrl(page) {
      const currentQuery = this.$route.query
      const pageStr = String(page)
      if (page <= 1) {
        if (currentQuery.page) {
          const { page: _p, ...rest } = currentQuery // eslint-disable-line no-unused-vars
          this.$router.replace({ query: rest }).catch(() => {})
        }
      } else if (currentQuery.page !== pageStr) {
        this.$router
          .replace({
            query: { ...currentQuery, page: pageStr },
          })
          .catch(() => {})
      }
    },

    // Load page from URL query params
    loadPageFromUrl() {
      const { query } = this.$route
      if (query.page) {
        const page = Number(query.page)
        if (page > 0) {
          this.currentPage = page
          return page
        }
      }
      return 1
    },

    // Sync sort to URL query params
    syncSortToUrl(sortBy, sortDesc) {
      this.$router
        .replace({
          query: { ...this.$route.query, sortBy, sortDesc: String(sortDesc) },
        })
        .catch(() => {})
    },

    // Sync filters to URL query params
    syncFiltersToUrl() {
      console.log(
        '[GenericOTList] syncFiltersToUrl CALLED - loadingFiltersFromUrl:',
        this.loadingFiltersFromUrl
      )
      // Skip if loading filters from URL
      if (this.loadingFiltersFromUrl) {
        console.log(
          '[GenericOTList] syncFiltersToUrl - SKIPPED because loadingFiltersFromUrl is true'
        )
        return
      }

      const { filters } = this
      console.log(
        '[GenericOTList] syncFiltersToUrl - filters:',
        JSON.stringify(filters)
      )
      const currentQuery = this.$route.query
      const newQuery = { ...currentQuery }

      // Add or update filter params in URL
      if (filters.tipoServicio) {
        newQuery.tipoServicio = filters.tipoServicio
      } else {
        delete newQuery.tipoServicio
      }

      if (filters.tipoCliente) {
        newQuery.tipoCliente = filters.tipoCliente
      } else {
        delete newQuery.tipoCliente
      }

      if (filters.tecnico) {
        newQuery.tecnico = filters.tecnico
      } else {
        delete newQuery.tecnico
      }

      if (filters.alertColor && filters.alertColor.length > 0) {
        newQuery.alertColor = filters.alertColor.join(',')
      } else {
        delete newQuery.alertColor
      }

      if (filters.on_site !== null && filters.on_site !== undefined) {
        // on_site is kept internal, not in URL
      }

      if (filters.despacho) {
        newQuery.despacho = filters.despacho
      } else {
        delete newQuery.despacho
      }

      if (filters.presupuesto) {
        newQuery.presupuesto = filters.presupuesto
      } else {
        delete newQuery.presupuesto
      }

      if (filters.garantia) {
        newQuery.garantia = filters.garantia
      } else {
        delete newQuery.garantia
      }

      // Remove sort params from query if no filters (to keep URL clean)
      if (
        !filters.tipoCliente &&
        !filters.tecnico &&
        (!filters.alertColor || filters.alertColor.length === 0) &&
        (filters.on_site === null || filters.on_site === '') &&
        !filters.despacho &&
        !filters.presupuesto &&
        !filters.garantia &&
        !filters.tipoServicio
      ) {
        delete newQuery.sortBy
        delete newQuery.sortDesc
      }

      // Only replace if query params are different to avoid NavigationDuplicated
      if (JSON.stringify(currentQuery) !== JSON.stringify(newQuery)) {
        this.$router.replace({ query: newQuery }).catch(() => {})
      }
    },

    // Load filters from URL query params
    loadFiltersFromUrl() {
      const { query } = this.$route
      const filterChanges = {}

      if (query.tipoServicio)
        filterChanges.tipoServicio = Number(query.tipoServicio)
      if (query.tipoCliente) filterChanges.tipoCliente = query.tipoCliente
      if (query.tecnico) filterChanges.tecnico = query.tecnico
      if (query.alertColor)
        filterChanges.alertColor = query.alertColor.split(',')
      // on_site is not persisted in URL
      if (query.despacho) filterChanges.despacho = query.despacho
      if (query.presupuesto) filterChanges.presupuesto = query.presupuesto
      if (query.garantia) filterChanges.garantia = query.garantia

      if (Object.keys(filterChanges).length > 0) {
        console.log(
          '[GenericOTList] loadFiltersFromUrl - Found filters in URL:',
          filterChanges
        )
        // Set flag to prevent syncing to URL during load
        this.loadingFiltersFromUrl = true

        // Use this.filters directly (from mapWritableState) to ensure reactivity
        Object.keys(filterChanges).forEach((key) => {
          console.log(
            `[GenericOTList] Setting filter ${key} =`,
            filterChanges[key]
          )
          this.filters[key] = filterChanges[key]
        })

        console.log(
          '[GenericOTList] After setting filters, this.filters:',
          JSON.stringify(this.filters)
        )

        // Use Vue.nextTick to ensure the watcher sees the updated values
        this.$nextTick(() => {
          console.log(
            '[GenericOTList] nextTick - this.filters:',
            JSON.stringify(this.filters)
          )
          // Now trigger the fetch manually since the watcher might not catch the changes
          const freshQueryParams = {
            servicio: this.filters.tipoServicio || 0,
            tecnico: this.filters.tecnico || 0,
            tipo_cliente: this.filters.tipoCliente || null,
            alert_color: this.filters.alertColor || [],
            on_site: this.filters.on_site || false,
            despacho: this.filters.despacho || null,
          }
          console.log(
            '[GenericOTList] nextTick - freshQueryParams:',
            JSON.stringify(freshQueryParams)
          )
          this.fetchData(1, this.sortBy, null, freshQueryParams).then(
            (data) => {
              this.setTabDataAndBump(data)
              this.loadingFiltersFromUrl = false
              // Now sync filters back to URL to ensure consistency
              this.syncFiltersToUrl()
            }
          )
        })
      } else {
        console.log(
          '[GenericOTList] loadFiltersFromUrl - No filters found in URL'
        )
      }
    },

    async fetchDataInitial(tabTitle) {
      const dataFilter = this.currentOtsByState?.filter(
        (ot) => ot.name === tabTitle
      )
      return {
        count: dataFilter?.[0]?.total || 0,
        next: null,
        previous: null,
        results: dataFilter?.[0]?.ots || [],
        loaded: true,
      }
    },

    async fetchData(page = 1, ordering, indexTabSelected, customFilters) {
      if (this.searchingFilter) return
      // this.loading = true // evitar loader global externo
      const fullPath = this.$route.path
      const pathName = fullPath.substring(1)
      if (this.controller && !pathName) {
        this.controller.abort()
      }
      this.controller = new AbortController()
      const { signal } = this.controller
      const lastName = this.tabs[this.selectedIndex].title
      const indexTab = indexTabSelected || this.selectedIndex
      const tabParams = this.tabs[indexTab].params || {}
      // Use customFilters if provided, otherwise fall back to queryParams
      const effectiveFilters = customFilters || this.queryParams
      console.log(
        '[GenericOTList] fetchData - effectiveFilters:',
        effectiveFilters
      )
      const args = {
        estados: this.tabs[indexTab].states,
        page,
        // Solo enviar aprobadas_3x3 si está explícitamente definido (no cuando es undefined)
        // De lo contrario, !!undefined = false se envía y filtra incorrectamente
        ...(tabParams.aprobadas_3x3 !== undefined
          ? { aprobadas_3x3: tabParams.aprobadas_3x3 }
          : {}),
        ot_list: this.otList,
        filters: effectiveFilters,
        tecnico_asignado_id: effectiveFilters.tecnico || this.autoTecnicoId,
        ordering,
        signal,
      }

      const response = await this.searchOT(args)
      // Refrescar contadores de tabs con el último response
      this.estadosCounters = (response.data && response.data.estados) || {}
      this.numberRows = response.data.count
      this.$nextTick(() => {
        const indexFinded = this.processedTabs.findIndex(
          (tab) => tab.title === lastName
        )
        this.selectedTab = indexFinded !== -1 ? indexFinded : 0
      })
      // this.loading = false // evitar loader global externo
      return response.data
    },

    getStatesCount(index) {
      if (!this.currentOtsFiltered.estados) return 0
      return Object.keys(this.currentOtsFiltered.estados).reduce(
        (accum, current) => {
          if (this.tabs[index].params?.aprobadas_3x3)
            return this.currentOtsFiltered.estados['Reparado 3x3']
          const toAdd =
            this.tabs[index].states.indexOf(current) > -1
              ? this.currentOtsFiltered.estados[current]
              : 0
          return accum + toAdd
        },
        0
      )
    },

    getStatusFilter(queryParams) {
      if (
        queryParams.alert_color?.length ||
        queryParams.despacho ||
        queryParams.servicio !== 0 ||
        queryParams.tecnico !== 0 ||
        queryParams.tipo_cliente
      )
        return true
      return false
    },

    initWebsockets() {
      this.socket = io(settings.webSocketsUrl)
      this.socket.on('orden_trabajo:updated', async ({ id }) => {
        let dataUse
        const nombreTab =
          this.titleTabSelected ||
          this.tabNameFor(this.tabs[this.selectedIndex])
        dataUse = this.isInitialDataState // eslint-disable-line
          ? this.currentOtsByState.find((ot) => ot.name === nombreTab)?.ots ||
            []
          : this.currentOts.results

        if (this.modalActionStatus) return

        if (dataUse.find((ot) => ot.ot === id)) {
          if (this.isInitialDataState) {
            const data = await this.getSingleOTAsListData({ ot: id })
            const stateIndex = this.currentOtsByState.findIndex(
              (state) => state.name === nombreTab
            )
            if (stateIndex !== -1) {
              const updatedState = {
                ...this.currentOtsByState[stateIndex],
                ots: this.currentOtsByState[stateIndex].ots.map((ot) =>
                  ot.ot === id ? data : ot
                ),
              }
              const newOtsByState = [
                ...this.currentOtsByState.slice(0, stateIndex),
                updatedState,
                ...this.currentOtsByState.slice(stateIndex + 1),
              ]
              this.SET_CURRENT_OTS_BY_STATES({ ots: newOtsByState })

              // fetchDataInitial NO consulta la red: lee currentOtsByState y
              // devuelve una pagina vacia si esa tab no esta cargada en el
              // cache. Escribirla borraba el listado completo en pantalla y
              // solo se recuperaba recargando (SILL-1521).
              if (this.isStateLoaded(nombreTab)) {
                const tabResponse = await this.fetchDataInitial(nombreTab)
                this.setTabDataAndBump(tabResponse)
              }
              this.loading = false
            }
          } else {
            const data = await this.getSingleOTAsListData({ ot: id })
            const index = dataUse.findIndex((ot) => ot.ot === id)
            if (index !== -1) {
              const newResults = [
                ...dataUse.slice(0, index),
                data,
                ...dataUse.slice(index + 1),
              ]
              await this.updateOtInCurrentPage({ ot: data })
              this.setTabDataAndBump({
                ...this.currentOts,
                results: newResults,
                count: this.currentOts?.count || 0,
              })
            }
          }
        }
        this.listTechnicians()
      })

      this.socket.on('orden_trabajo:deleted', async ({ id }) => {
        if (!this.modalActionStatus) {
          const ot_number = id
          if (!this.isInitialData) {
            this.removeOtFromResults({ ot_number })
          } else {
            const newOtsByState = JSON.parse(
              JSON.stringify(this.currentOtsByState)
            ).map((state) => {
              return {
                ...state,
                ots: state.ots.filter((ot) => ot.ot !== ot_number),
              }
            })
            this.SET_CURRENT_OTS_BY_STATES({ ots: newOtsByState })

            const tabResponse = await this.fetchDataInitial(
              this.titleTabSelected || this.tabs[this.selectedIndex]?.title
            )
            this.setTabDataAndBump(tabResponse)
            this.loading = false
          }
        }
        this.listTechnicians()
      })
    },
  },
  watch: {
    // Watch for tab changes and sync to URL
    selectedTab(newVal) {
      console.log('[GenericOTList] selectedTab changed to:', newVal)
      const tabTitle = this.processedTabs[newVal]?.title
      if (tabTitle) {
        this.tab = tabTitle // Sync to Pinia
        this.syncTabToUrl(tabTitle)
      }
    },
    // Watch for external reset of tab from Pinia
    tab(newVal) {
      if (newVal === null && this.selectedTab !== 0) {
        this.selectedTab = 0
      } else if (newVal) {
        const idx = this.processedTabs.findIndex((t) => t.title === newVal)
        if (idx !== -1 && idx !== this.selectedTab) {
          this.selectedTab = idx
        }
      }
    },
    // Deep watcher on filters to catch all filter changes from URL
    filters: {
      handler() {
        // Skip when loading filters from URL - loadFiltersFromUrl's $nextTick handles the fetch
        if (this.loadingFiltersFromUrl) {
          return
        }
        // When not loading from URL, sync filters to URL
        this.syncFiltersToUrl()
      },
      deep: true,
    },
    loadingInputSearch(newVal) {
      this.loading = newVal
    },
    techFilterChanged(newVal) {
      if (this.searchingFilter && !this.flagWatcher) {
        this.flagWatcher = true
        this.changeTable()
      }
      // Build current filters from this.filters
      const currentFilters = {
        servicio: this.filters.tipoServicio || 0,
        tecnico: this.filters.tecnico || 0,
        tipo_cliente: this.filters.tipoCliente || null,
        alert_color: this.filters.alertColor || [],
        on_site: this.filters.on_site || false,
        despacho: this.filters.despacho || null,
      }
      if (!newVal && !this.isInitialDataState) {
        this.fetchData(1, this.sortBy, null, currentFilters).then((data) =>
          this.setTabDataAndBump(data)
        )
      }
      // Fetch data when loading from URL
      if (this.loadingFiltersFromUrl) {
        this.fetchData(1, this.sortBy, null, currentFilters).then((data) =>
          this.setTabDataAndBump(data)
        )
      }
      // Skip sync if loading filters from URL
      if (!this.loadingFiltersFromUrl) {
        // Sync filters to URL
        this.syncFiltersToUrl()
      }
    },
    tipoDespacho(newVal) {
      if (this.searchingFilter && !this.flagWatcher) {
        this.flagWatcher = true
        this.changeTable()
      }
      // Build current filters from this.filters
      const currentFilters = {
        servicio: this.filters.tipoServicio || 0,
        tecnico: this.filters.tecnico || 0,
        tipo_cliente: this.filters.tipoCliente || null,
        alert_color: this.filters.alertColor || [],
        on_site: this.filters.on_site || false,
        despacho: this.filters.despacho || null,
      }
      if (!newVal && !this.isInitialDataState) {
        this.fetchData(1, this.sortBy, null, currentFilters).then((data) =>
          this.setTabDataAndBump(data)
        )
      }
      // Fetch data when loading from URL
      if (this.loadingFiltersFromUrl) {
        this.fetchData(1, this.sortBy, null, currentFilters).then((data) =>
          this.setTabDataAndBump(data)
        )
      }
      // Skip sync if loading filters from URL
      if (!this.loadingFiltersFromUrl) {
        // Sync filters to URL
        this.syncFiltersToUrl()
      }
    },
    tipoServicio(newVal) {
      if (this.searchingFilter) {
        this.flagWatcher = true
        this.changeTable()
      }
      // Build current filters from this.filters
      const currentFilters = {
        servicio: this.filters.tipoServicio || 0,
        tecnico: this.filters.tecnico || 0,
        tipo_cliente: this.filters.tipoCliente || null,
        alert_color: this.filters.alertColor || [],
        on_site: this.filters.on_site || false,
        despacho: this.filters.despacho || null,
      }
      // Fetch data when filter changes (including when loading from URL)
      if (this.loadingFiltersFromUrl || (!newVal && !this.isInitialDataState)) {
        this.fetchData(1, this.sortBy, null, currentFilters).then((data) =>
          this.setTabDataAndBump(data)
        )
      }
      // Skip sync if loading filters from URL
      if (!this.loadingFiltersFromUrl) {
        // Sync filters to URL
        this.syncFiltersToUrl()
      }
    },
    tipoCliente(newVal) {
      console.log(
        '[GenericOTList] tipoCliente watcher - newVal:',
        newVal,
        'loadingFiltersFromUrl:',
        this.loadingFiltersFromUrl
      )
      if (this.searchingFilter && !this.flagWatcher) {
        this.flagWatcher = true
        this.changeTable()
      }
      // Build current filters from this.filters
      const currentFilters = {
        servicio: this.filters.tipoServicio || 0,
        tecnico: this.filters.tecnico || 0,
        tipo_cliente: this.filters.tipoCliente || null,
        alert_color: this.filters.alertColor || [],
        on_site: this.filters.on_site || false,
        despacho: this.filters.despacho || null,
      }
      console.log(
        '[GenericOTList] tipoCliente watcher - currentFilters:',
        JSON.stringify(currentFilters)
      )
      // Fetch data when filter changes (including when loading from URL)
      if (this.loadingFiltersFromUrl || (!newVal && !this.isInitialDataState)) {
        console.log('[GenericOTList] tipoCliente watcher - fetching data')
        this.fetchData(1, this.sortBy, null, currentFilters).then((data) =>
          this.setTabDataAndBump(data)
        )
      }
      // Skip sync if loading filters from URL
      if (!this.loadingFiltersFromUrl) {
        // Sync filters to URL
        this.syncFiltersToUrl()
      }
    },
    alertColor(newVal) {
      if (this.searchingFilter && !this.flagWatcher) {
        this.flagWatcher = true
        this.changeTable()
      }
      // Build current filters from this.filters
      const currentFilters = {
        servicio: this.filters.tipoServicio || 0,
        tecnico: this.filters.tecnico || 0,
        tipo_cliente: this.filters.tipoCliente || null,
        alert_color: this.filters.alertColor || [],
        on_site: this.filters.on_site || false,
        despacho: this.filters.despacho || null,
      }
      // Fetch data when filter changes (including when loading from URL)
      if (this.loadingFiltersFromUrl || (!newVal && !this.isInitialDataState)) {
        this.fetchData(1, this.sortBy, null, currentFilters).then((data) =>
          this.setTabDataAndBump(data)
        )
      }
      // Skip sync if loading filters from URL
      if (!this.loadingFiltersFromUrl) {
        // Sync filters to URL
        this.syncFiltersToUrl()
      }
    },
    dataInputSeach() {
      this.numberRows = this.dataInput.count
      if (!this.loadingFiltersFromUrl) {
        this.currentPage = 1
        this.syncPageToUrl(1)
      }
    },
    stateIsChanged(value) {
      if (value) {
        if (this.modalActionStatus) return
        this.searchOT({ estados: this.tabs[0].states, ot_list: this.otList })
        this.SET_STATE_IS_CHANGED(false)
      }
    },
    currentOtsFiltered: {
      async handler() {
        // Modo inicial (preload por estados) → usamos store por estado
        if (this.isInitialDataState && !this.isSearched) {
          const title =
            this.processedTabs[this.selectedTab]?.title ||
            this.titleTabSelected ||
            this.tabs[this.selectedIndex]?.title

          if (title) {
            const dataTab = await this.fetchDataInitial(title)
            this.setTabDataAndBump(dataTab)
          }
        } else {
          // Modo búsqueda o paginación normal (del backend)
          this.setTabDataAndBump(this.currentOts)
        }
      },
    },
    watchedFilters: {
      async handler(newVal, oldVal) {
        if (JSON.stringify(newVal) === JSON.stringify(oldVal)) return

        // Skip sync if loading filters from URL
        if (this.loadingFiltersFromUrl) return

        // Sync filters to URL and reset page to 1
        this.syncFiltersToUrl()
        this.currentPage = 1
        this.syncPageToUrl(1)

        this.loading = true

        // Determine ordering
        let ordering = null
        if (this.sortBy) {
          ordering = this.sortDesc ? `-${this.sortBy}` : this.sortBy
          this.syncSortToUrl(this.sortBy, this.sortDesc)
        }

        if (!this.$route.params.dontSearch && !this.searchingFilter) {
          // Always fetch for the first available tab (with current selected tab's states)
          if (this.selectedTab === -1) this.selectedTab = 0

          const activeTab =
            this.processedTabs[this.selectedTab] || this.processedTabs[0]
          if (!activeTab) {
            this.loading = false
            return
          }

          const activeTabParams = activeTab.params || {}
          const response = await this.searchOT({
            estados: activeTab.states,
            ot_list: this.otList,
            filters: this.queryParams,
            tecnico_asignado_id: this.filters.tecnico || this.autoTecnicoId,
            ordering,
            page: 1,
            ...(activeTabParams.aprobadas_3x3 !== undefined
              ? { aprobadas_3x3: activeTabParams.aprobadas_3x3 }
              : {}),
          })

          // Actualizar contadores con la búsqueda
          this.estadosCounters = (response.data && response.data.estados) || {}
          this.numberRows = response.data.count

          if (
            response.data.count > 0 ||
            !this.getStatusFilter(this.queryParams)
          ) {
            // If count > 0 OR if we are clearing filters (getStatusFilter is false), show results
            this.setTabDataAndBump(response.data)
            // Ensure URL has the current tab name
            this.syncTabToUrl(activeTab.title)
          } else {
            // Current tab has no results AND we are currently filtering, find first tab that does
            const firstTabWithResults = this.processedTabs[0]
            if (firstTabWithResults) {
              const firstTabParams = firstTabWithResults.params || {}
              const responseOT = await this.searchOT({
                estados: firstTabWithResults.states,
                ot_list: this.otList,
                filters: this.queryParams,
                tecnico_asignado_id: this.filters.tecnico || this.autoTecnicoId,
                ordering,
                page: 1,
                ...(firstTabParams.aprobadas_3x3 !== undefined
                  ? { aprobadas_3x3: firstTabParams.aprobadas_3x3 }
                  : {}),
              })
              this.numberRows = responseOT.data.count
              this.setTabDataAndBump(responseOT.data)
              this.selectedTab = 0
              // Sync the new tab name to URL
              this.syncTabToUrl(firstTabWithResults.title)
            } else {
              this.setTabDataAndBump(response.data)
            }
          }
        }
        this.loading = false
      },
      deep: true,
    },
    isInitialDataState: {
      handler(value) {
        this.isInitialData = value
      },
      immediate: true,
      deep: true,
    },
  },
  mounted() {
    // Only reset tipoServicio if no filters were loaded from URL
    if (!this.loadingFiltersFromUrl && !this.$route.query.tipoServicio) {
      this.filters.tipoServicio = null
    }
  },
}
</script>

<style lang="scss" scoped>
@import '~bootstrap/scss/functions';
@import '~bootstrap/scss/variables';
@import '~bootstrap/scss/mixins';

.container-list {
  box-shadow: 0px 3px 6px #00000029;
}

.ver-pedido {
  color: #fff;
  background-color: var(--button);
  border-color: var(--button);
  width: 90px;
  height: 40px;
  border-radius: 5px;
  font-weight: 600;
  &:disabled {
    background-color: #7d93ff;
    border-color: #7d93ff;
    cursor: not-allowed;
  }
}

.ot {
  color: #41509b;
  font-weight: bold;
}
.header-tecnico {
  font-size: 1.2em;
  font-weight: 700;
}

::v-deep .nav-pills .nav-link.active,
.nav-pills .show > .nav-link {
  color: #fff;
  background-color: var(--button);
  font-weight: bold;
}

::v-deep .card-header {
  background-color: #ffffff;
  overflow-x: auto;
  ul {
    overflow-x: visible;
  }
  a {
    color: #495057;
    font-weight: bold;
    &:hover {
      color: #495057;
    }
  }
}

::v-deep table th {
  color: #495057;
}
a.router-link-active {
  color: var(--button);
}
.text-danger {
  color: var(--button) !important;
}
::v-deep .card-body {
  padding: 0;
}
.text-danger[data-v-76755bd8] {
  color: #d32b2b !important;
}

.page-link {
  position: relative;
  display: block;
  padding: 0.5rem 0.75rem;
  margin-left: -1px;
  line-height: 1.25;
  color: var(--button) !important;
  background-color: #fff;
  border: 1px solid #dee2e6;
}

.ot-cell {
  display: flex;
  justify-content: space-between;
  flex-direction: row;
  @include media-breakpoint-down(sm) {
    flex-direction: column;
    align-items: center;
    gap: 10px;
  }
}

::v-deep .tabla-tbody td {
  @include media-breakpoint-down(sm) {
    padding: 10px;
  }
}
::v-deep .tabla-thead th {
  @include media-breakpoint-down(sm) {
    padding: 4px 10px 4px;
  }
}
</style>
